import React, { useState, useMemo } from 'react'
import { Dropdown } from 'semantic-ui-react'
import styled from 'styled-components'
import debounce from 'lodash/debounce'
import { AutoFocusSemanticUiComponent } from 'components/AutoFocusSemanticUiComponent'

/**
 *
 * @param {object} props
 * @param {import('semantic-ui-react').DropdownItemProps[]} props.options
 * @param {*} props.defaultValue
 * @param {function} props.onChange
 * @param {function} props.onSearchChange
 * @param {boolean} props.loading
 * @param {boolean} [props.shouldAutoFocus]
 */
export default function AudienceRuleAutoCompleteInput({
  options,
  defaultValue,
  onChange,
  onSearchChange,
  loading,
  shouldAutoFocus,
}) {
  const [selectedValue, setSelectedValue] = useState(defaultValue)
  const [searchQuery, setSearchQuery] = useState('')
  function handleChange(_, { value }) {
    onChange && onChange(value)
    setSelectedValue(value)
  }

  const debouncedHandleSearchChange = useMemo(() => {
    function handleSearchChange(searchQuery) {
      if (shouldSearch(searchQuery)) {
        onSearchChange(searchQuery)
      }
    }

    return debounce(handleSearchChange, 500)
  }, [onSearchChange])

  function handleSearchChange(_, { searchQuery }) {
    setSearchQuery(searchQuery)
    debouncedHandleSearchChange(searchQuery)
  }

  return (
    <CustomDropdownStyleWrapper>
      <AutoFocusSemanticUiComponent functionName={shouldAutoFocus && 'open'}>
        <Dropdown
          fluid
          search={customSearch}
          searchInput={{
            required: !selectedValue,
          }}
          selection
          options={options}
          defaultValue={defaultValue}
          onChange={handleChange}
          text={selectedValue}
          onSearchChange={handleSearchChange}
          noResultsMessage={getMessage(loading, searchQuery)}
        />
      </AutoFocusSemanticUiComponent>
    </CustomDropdownStyleWrapper>
  )
}

const CustomDropdownStyleWrapper = styled.div`
  .ui.dropdown > .text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ui.dropdown .menu > .item {
    transform: scaleY(-1);

    > span {
      display: block;
      transform: scaleY(-1);
      margin: 0;
      float: none;
    }

    > .description,
    .text {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`

function customSearch(options, query) {
  return options.filter((option) => {
    const textToSearch = option.text + (option.description || '')
    return textToSearch.toLowerCase().indexOf(query.toLowerCase()) >= 0
  })
}

function getMessage(loading, searchQuery) {
  if (loading) {
    return 'Searching...'
  }

  if (!shouldSearch(searchQuery)) {
    return 'Start typing to search more'
  }

  return 'No result found.'
}

function shouldSearch(searchQuery = '') {
  return searchQuery.length >= 3
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AudienceRuleAutoCompleteInput/index.js